// Grupo no modo "um chamado por conexão" (groupTicketUnify=disabled): a
// mensagem é gravada uma vez, como fromMe, pela conexão que a enviou, e o
// chamado de cada conexão exibe a conversa inteira do grupo. Vista de OUTRA
// conexão da empresa, ela é de um participante do grupo — é assim que aparece
// no WhatsApp de quem está olhando, e a conexão dele não poderia editá-la nem
// apagá-la para todos.

import { resolveGroupSenderName } from "./groupSenderName";

/**
 * Conexão que enviou uma mensagem fromMe: `sentByWhatsappId`, que o backend
 * resolve pelo participant; sem ele, a do chamado, porque nesse modo o eco fica
 * no chamado da conexão que enviou. 0 quando não é fromMe ou não se sabe.
 */
export const getSenderWhatsappId = (message) => {
  if (!message?.fromMe) return 0;
  return Number(message.sentByWhatsappId) || Number(message.ticket?.whatsappId) || 0;
};

const asParticipantMessage = (message, senderWhatsappId, connections) => {
  const connection = (connections || []).find((w) => Number(w.id) === senderWhatsappId);
  // Sem participant a cadeia para antes do número: o nome da conexão diz mais.
  const name = resolveGroupSenderName({ ...message, participant: null }) || connection?.name || "";
  return {
    ...message,
    fromMe: false,
    sentByOtherConnection: true,
    ...(name ? { participantName: name } : {}),
  };
};

/**
 * A mensagem como a conexão `viewerWhatsappId` a vê. Enviada por outra conexão
 * (ela ou a citada), devolve uma cópia de participante: `fromMe: false`,
 * `sentByOtherConnection: true` e `participantName`. Nos demais casos devolve a
 * mesma referência.
 */
export const asSeenByConnection = (message, viewerWhatsappId, connections) => {
  const viewerId = Number(viewerWhatsappId) || 0;
  if (!message || !viewerId) return message;

  let seen = message;
  const senderId = getSenderWhatsappId(message);
  if (senderId && senderId !== viewerId) {
    seen = asParticipantMessage(message, senderId, connections);
  }

  const quotedSenderId = getSenderWhatsappId(message.quotedMsg);
  if (quotedSenderId && quotedSenderId !== viewerId) {
    seen = { ...seen, quotedMsg: asParticipantMessage(message.quotedMsg, quotedSenderId, connections) };
  }

  return seen;
};
